import { c as _c } from "react/compiler-runtime";
import { Heading, VStack, SimpleGrid, Icon, Text, Box, Input, InputGroup, HStack, IconButton, Field } from '@chakra-ui/react';
import { AnimatedSection, useAnimationContext } from '@src/components/sco/AnimatedSection';
import { RequestExampleCard } from '@src/components/sco/RequestRoadmap/RequestExampleCard';
import { useDelayedText } from '@src/components/sco/TypingText';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { motion, AnimatePresence } from 'framer-motion';
import { useEffect, useState, useRef } from 'react';
import { GiTeacher } from 'react-icons/gi';
import { LuBadgeDollarSign, LuHammer, LuHandshake, LuRotateCw, LuSearch, LuUsersRound } from 'react-icons/lu';
export const CreateRequestAnim = () => {
  const $ = _c(3);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  getBreakpointValue([true, true, false, false, false]);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    };
    t1 = {
      opacity: 0,
      y: 20
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <AnimatedSection height="100%" width="100%" style={t0} variants={{
      hidden: t1,
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 0.6,
          ease: [0.34, 1.56, 0.64, 1]
        }
      }
    }}><AnimationSequence /></AnimatedSection>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
const AnimationSequence = () => {
  const $ = _c(25);
  const {
    isVisible
  } = useAnimationContext();
  const [resetKey, setResetKey] = useState(0);
  const [showChooseOutcome, setShowChooseOutcome] = useState(true);
  const [showChooseFundingAmount, setShowChooseFundingAmount] = useState(false);
  const [showRequestExampleCard, setShowRequestExampleCard] = useState(false);
  const [highlightFirstItem, setHighlightFirstItem] = useState(false);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t0;
  if ($[0] !== getBreakpointValue) {
    t0 = getBreakpointValue([true, true, false, false, false]);
    $[0] = getBreakpointValue;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isMobile = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setShowChooseOutcome(true);
      setShowChooseFundingAmount(false);
      setShowRequestExampleCard(false);
      setHighlightFirstItem(false);
      setResetKey(_temp);
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const resetAnimation = t1;
  let t2;
  if ($[3] !== isVisible) {
    t2 = () => {
      if (!isVisible) {
        return;
      }
      const timer1 = setTimeout(() => {
        setHighlightFirstItem(true);
      }, 1000);
      const timer2 = setTimeout(() => {
        setShowChooseOutcome(false);
        setTimeout(() => {
          setShowChooseFundingAmount(true);
        }, 500);
      }, 2000);
      return () => {
        clearTimeout(timer1);
        clearTimeout(timer2);
      };
    };
    $[3] = isVisible;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isVisible || $[6] !== resetKey) {
    t3 = [isVisible, resetKey];
    $[5] = isVisible;
    $[6] = resetKey;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useEffect(t2, t3);
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <HStack justify="flex-end" marginBottom={4} opacity={0.5} position="absolute" right={0} top={0} width="full"><IconButton aria-label="Reset animation" size="sm" variant="ghost" onClick={resetAnimation}><Icon asChild={true}><LuRotateCw /></Icon></IconButton></HStack>;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== highlightFirstItem || $[10] !== showChooseOutcome) {
    t5 = showChooseOutcome && <motion.div key="choose-outcome" exit={{
      opacity: 0
    }} initial={{
      opacity: 1
    }} style={{
      width: "100%",
      height: "100%"
    }} transition={{
      duration: 0.8
    }}><ChooseOutcome highlightFirstItem={highlightFirstItem} /></motion.div>;
    $[9] = highlightFirstItem;
    $[10] = showChooseOutcome;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== resetKey || $[13] !== showChooseFundingAmount) {
    t6 = showChooseFundingAmount && <motion.div key="choose-funding-amount" animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} initial={{
      opacity: 0
    }} style={{
      width: "100%",
      height: "100%"
    }} transition={{
      duration: 0.8
    }}><ChooseFundingAmount resetKey={resetKey} onTypingComplete={() => {
        setTimeout(() => {
          setShowChooseFundingAmount(false);
          setTimeout(() => {
            setShowRequestExampleCard(true);
          }, 800);
        }, 2000);
      }} /></motion.div>;
    $[12] = resetKey;
    $[13] = showChooseFundingAmount;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== isMobile || $[16] !== showRequestExampleCard) {
    t7 = showRequestExampleCard && <motion.div key="request-example-card" animate={{
      opacity: 1
    }} initial={{
      opacity: 0
    }} style={{
      width: "100%",
      height: "100%"
    }} transition={{
      duration: 0.8
    }}><RequestExampleCard investors={["John Doe", "Jane Doe", "Jim Doe"]} noOfMatches="1,452" tags={["Funding", "Early-Stage", "Healthcare", "Columbus, OH"]} title="Early-stage healthcare startup in Columbus, OH looking to raise $1,000,000." buttonGroupProps={{
        display: isMobile ? "grid" : "flex",
        gridTemplateColumns: isMobile ? "repeat(2, 1fr)" : "none",
        gap: 2
      }} parentStackProps={{
        height: "100%",
        textAlign: "center",
        backgroundImage: `url(${require("@public/assets/backgrounds/wave-texture-purple-sm.jpg").default.src})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundColor: "transparent"
      }} statsStackProps={{
        justifyContent: "center"
      }} titleProps={{
        size: isMobile ? "md" : "lg"
      }} /></motion.div>;
    $[15] = isMobile;
    $[16] = showRequestExampleCard;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t5 || $[19] !== t6 || $[20] !== t7) {
    t8 = <AnimatePresence mode="wait">{t5}{t6}{t7}</AnimatePresence>;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== resetKey || $[23] !== t8) {
    t9 = <>{t4}<Box key={resetKey} height="100%" position="relative" width="full">{t8}</Box></>;
    $[22] = resetKey;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
};
const ChooseOutcome = t0 => {
  const $ = _c(8);
  const {
    highlightFirstItem
  } = t0;
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t1;
  if ($[0] !== getBreakpointValue) {
    t1 = getBreakpointValue([true, true, false, false, false]);
    $[0] = getBreakpointValue;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isMobile = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Heading color="colorPalette.fg" size="lg" textAlign="center">What do you want to accomplish?</Heading>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== highlightFirstItem || $[4] !== isMobile) {
    t3 = ChooseOutcomeItemArray.map((item, index) => <ChooseOutcomeItem key={item.title} isHighlighted={highlightFirstItem && index === 0} title={item.title} icon={<Icon asChild={true} boxSize={isMobile ? 2 : 6} color="colorPalette.fg/50"><item.icon /></Icon>} />);
    $[3] = highlightFirstItem;
    $[4] = isMobile;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <VStack align="center" gap={4} height="100%" justify="center" width="full">{t2}<SimpleGrid columns={3} gap={2} width="full">{t3}</SimpleGrid></VStack>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
const ChooseOutcomeItem = props => {
  const $ = _c(11);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const isMobile = getBreakpointValue([true, true, false, false, false]);
  const t0 = props.isHighlighted ? "teal.muted" : "colorPalette.bg/50";
  const t1 = props.isHighlighted ? "teal.focusRing" : "colorPalette.border";
  const t2 = props.isHighlighted ? "colorPalette.fg" : "colorPalette.fg/70";
  const t3 = isMobile ? "xs" : "sm";
  const t4 = isMobile ? "100%" : "normal";
  const t5 = props.isHighlighted ? 1 : 0.7;
  let t6;
  if ($[0] !== props.title || $[1] !== t2 || $[2] !== t3 || $[3] !== t4 || $[4] !== t5) {
    t6 = <Text color={t2} fontSize={t3} lineHeight={t4} opacity={t5} textAlign="center">{props.title}</Text>;
    $[0] = props.title;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== props.icon || $[7] !== t0 || $[8] !== t1 || $[9] !== t6) {
    t7 = <VStack align="center" bgColor={t0} border="1px solid" borderColor={t1} borderRadius="md" boxShadow="md" gap={2} justify="center" paddingX={2} paddingY={4} transition="all 0.3s ease" width="full">{props.icon}{t6}</VStack>;
    $[6] = props.icon;
    $[7] = t0;
    $[8] = t1;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
};
const ChooseOutcomeItemArray = [{
  title: 'Raise Funding',
  icon: LuBadgeDollarSign
}, {
  title: 'Get Customers',
  icon: LuSearch
}, {
  title: 'Build Product',
  icon: LuHammer
}, {
  title: 'Find a Co-Founder',
  icon: LuUsersRound
}, {
  title: 'Find Advisors',
  icon: GiTeacher
}, {
  title: 'Hire Talent',
  icon: LuHandshake
}];
const ChooseFundingAmount = t0 => {
  const $ = _c(33);
  const {
    onTypingComplete,
    resetKey
  } = t0;
  const {
    isVisible
  } = useAnimationContext();
  const [isTyping, setIsTyping] = useState(false);
  const [isComplete, setIsComplete] = useState(false);
  const inputRef = useRef(null);
  const delayedText = useDelayedText("1,000,000", 200, isTyping);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const isMobile = getBreakpointValue([true, true, false, false, false]);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsTyping(false);
      setIsComplete(false);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== resetKey) {
    t2 = [resetKey];
    $[1] = resetKey;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== isVisible) {
    t3 = () => {
      if (!isVisible) {
        return;
      }
      const timer = setTimeout(() => {
        setIsTyping(true);
      }, 1000);
      return () => clearTimeout(timer);
    };
    $[3] = isVisible;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isVisible || $[6] !== resetKey) {
    t4 = [isVisible, resetKey];
    $[5] = isVisible;
    $[6] = resetKey;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[8] !== delayedText || $[9] !== isComplete || $[10] !== isTyping || $[11] !== onTypingComplete) {
    t5 = () => {
      if (delayedText === "1,000,000" && isTyping && !isComplete) {
        setIsComplete(true);
        setIsTyping(false);
        onTypingComplete();
      }
    };
    t6 = [delayedText, "1,000,000", isTyping, isComplete, onTypingComplete];
    $[8] = delayedText;
    $[9] = isComplete;
    $[10] = isTyping;
    $[11] = onTypingComplete;
    $[12] = t5;
    $[13] = t6;
  } else {
    t5 = $[12];
    t6 = $[13];
  }
  useEffect(t5, t6);
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Icon asChild={true} boxSize={6} color="colorPalette.fg/50"><LuBadgeDollarSign /></Icon>;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const t8 = isMobile ? "lg" : "xl";
  let t9;
  if ($[15] !== t8) {
    t9 = <HStack justify="center" width="full">{t7}<Heading color="colorPalette.fg" size={t8} textAlign="center">Raise Funding</Heading></HStack>;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const t10 = isMobile ? "sm" : "md";
  let t11;
  if ($[17] !== t10) {
    t11 = <Text fontSize={t10} textAlign="center" textStyle="heading" color="colorPalette.fg">How much do you need to raise?</Text>;
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  const t12 = isTyping ? "2px solid" : "2px solid";
  const t13 = isTyping ? "colorPalette.focusRing" : "transparent";
  const t14 = isTyping ? "0 0 0 1px var(--chakra-colors-colorPalette-focusRing)" : undefined;
  const t15 = isMobile ? "sm" : "lg";
  let t16;
  if ($[19] !== delayedText || $[20] !== t15) {
    t16 = <InputGroup endElement="USD" startElement="$"><Input ref={inputRef} readOnly={true} size={t15} value={delayedText} /></InputGroup>;
    $[19] = delayedText;
    $[20] = t15;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  let t17;
  if ($[22] !== t12 || $[23] !== t13 || $[24] !== t14 || $[25] !== t16) {
    t17 = <Box border={t12} borderColor={t13} borderRadius="md" boxShadow={t14} transition="border-color 0.3s ease" width="full">{t16}</Box>;
    $[22] = t12;
    $[23] = t13;
    $[24] = t14;
    $[25] = t16;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== t11 || $[28] !== t17) {
    t18 = <Field.Root>{t11}{t17}</Field.Root>;
    $[27] = t11;
    $[28] = t17;
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  let t19;
  if ($[30] !== t18 || $[31] !== t9) {
    t19 = <VStack align="center" gap={4} height="100%" justify="center" width="full">{t9}{t18}</VStack>;
    $[30] = t18;
    $[31] = t9;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  return t19;
};
function _temp(prev) {
  return prev + 1;
}